import React from 'react';
import { CircleIcon, Calendar03Icon, TickDouble02Icon } from 'hugeicons-react';
import '../../assets/css/notification/notification-list.css';

const NotificationList = ({
  notifications = [],
  selectedNotifications,
  handleSelect,
  handleSelectAll,
  isAllSelected,
  formatDate,
}) => {
  const getCategoryColor = (category) => {
    const colors = {
      'Measure Data': '#0E76BC',
      'Measure': '#0E76BC',
      'Target': '#1EAD5C',
      'Account': '#F59E0B',
      'default': '#6b7280'
    };
    return colors[category] || colors.default;
  };

  return (
    <div className="notification-list-container">
      {notifications.length > 0 ? (
        <div className="notification-list">
          {notifications.map((notification, index) => {
            const isSelected = isAllSelected || selectedNotifications.includes(index);
            const categoryColor = getCategoryColor(notification.category);
            
            return (
              <div
                key={index}
                className={`notification-item ${notification.is_read ? 'read' : 'unread'} ${isSelected ? 'selected' : ''}`}
                onClick={(e) => {
                  // Don't toggle if clicking directly on the checkbox
                  if (e.target.type !== 'checkbox' && !e.target.closest('.notification-checkbox-wrapper')) {
                    handleSelect(index);
                  }
                }}
              >
                <div className="notification-status-pill">
                  {notification.is_read ? (
                    <TickDouble02Icon size={18} className="status-tick" />
                  ) : (
                    <div className="status-dot-unread"></div>
                  )}
                </div>
                
                <div className="notification-content">
                  <div className="notification-header">
                    <span
                      className="notification-category-label"
                      style={{
                        color: categoryColor,
                        backgroundColor: `${categoryColor}15`
                      }}
                    >
                      {notification.category}
                    </span>
                    {!notification.is_read && (
                      <span className="notification-read-label unread">
                        New
                      </span>
                    )}
                  </div>
                  <p className="notification-summary">{notification.summary}</p>
                  <div className="notification-footer">
                    <div className="notification-date">
                      <Calendar03Icon size={14} />
                      <span>{formatDate ? formatDate(notification.date_time_created) : notification.date_time_created}</span>
                    </div>
                  </div>
                </div>

                <label
                  className={`notification-checkbox-wrapper ${isSelected ? 'checked' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSelect(index);
                  }}
                >
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => {}}
                  />
                  <span className="checkbox-custom" />
                </label>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="notification-empty">
          <p>No notifications found</p>
        </div>
      )}
    </div>
  );
};

export default NotificationList;

